import { FormProvider, useForm } from "react-hook-form";
import { AppDialog } from "../../../AppDialog/AppDialog";
import { DefaultDateField } from "../../../forms/inputs/dateField/DefaultDateField";
import { DefaultButton } from "../../../button/defaultButton/DefaultButton";
import styles from "./CreateStandaloneWorkoutDialog.module.scss";

interface ICreateStandaloneWorkoutDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: (date: Date) => void;
  isCreating: boolean;
}

interface ICreateStandaloneWorkoutForm {
  workoutDate: Date | null;
}

/**
 * The subscribed-user "+" create flow: pick a date (defaults to today) for a new
 * standalone workout. On confirm the parent creates the workout and opens it.
 */
export const CreateStandaloneWorkoutDialog = ({
  visible,
  onHide,
  onConfirm,
  isCreating,
}: ICreateStandaloneWorkoutDialogProps) => {
  const form = useForm<ICreateStandaloneWorkoutForm>({
    defaultValues: { workoutDate: new Date() },
  });

  const submit = form.handleSubmit((values) => {
    if (!values.workoutDate) return;
    onConfirm(values.workoutDate);
  });

  return (
    <AppDialog
      header="Нова тренировка"
      visible={visible}
      onHide={onHide}
      className={styles.dialog}
    >
      <FormProvider {...form}>
        <div className={styles.content}>
          <DefaultDateField
            name="workoutDate"
            label="Дата и час"
            width="100%"
            showTime
            dateFormat="dd/mm/yy"
          />
          <DefaultButton
            design="default"
            label="Създай"
            onClick={submit}
            loading={isCreating}
            disabled={isCreating}
            className={styles.button}
          />
        </div>
      </FormProvider>
    </AppDialog>
  );
};
